<template>
  <div class="center-slider" :class="'center-slider_' + item.theme">
    <div class="center-slider__container _pa-8">
      <picture v-if="item.images && item.images.length">
        <source
          v-for="(img, ind) in item.images"
          :key="ind"
          :srcset="img.src"
          :media="img.media"
        />
        <img
          class="center-slider__img"
          :src="item.images[item.images.length - 1].src"
        />
      </picture>
      <div class="center-slider__text-container">
        <h3
          class="center-slider__text-title _mb-2 _fw-600 _fs-32 _lh-38 _fs-sm-20 _lh-sm-24"
          v-html="item.title"
        ></h3>
        <p
          class="center-slider__text-description _fs-24 _lh-32 _fs-sm-16 _lh-sm-24"
          v-html="item.descr"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherBanner',
  props: {
    item: Object,
  },
  data: () => ({}),
}
</script>

<style lang="scss" scoped>
.center-slider {
  &__container {
    // height: 244px;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    @media screen and (max-width: 1220px) {
      // height: 308px;
    }
    @media screen and (max-width: 743px) {
      // height: 456px;
    }
  }
  &__img {
    // position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: 0;
    @media screen and (max-width: 1220px) {
      // height: auto;
    }
  }

  &__text-container {
    position: relative;
    width: 50%;
    @media screen and (max-width: 1220px) {
      width: 45%;
    }

    @media screen and (max-width: 743px) {
      width: auto;
    }
  }
}

.center-slider {
  &_dark {
    .center-slider {
      &__text {
        &-title {
          color: #323131;
        }
        &-description {
          color: color(dark-grey);
        }
      }
    }
  }

  &_light {
    .center-slider {
      &__text {
        &-title {
          color: color(white);
        }
        &-description {
          color: color(white);
        }
      }
    }
  }
}
</style>
